import { JSX, useEffect, useState } from 'react';
import './TuningInformationCard.css'
import { translations } from '../../../configs/translations';
import { Language } from '../../../context/LanguageContext';
import { VehicleService } from '../../../services/VehicleService';
import { ColorBlock } from './blocks/ColorBlock';
import { RGBColor } from 'react-color';
import { Tunings } from '../../../enums/Tunings';

export interface TuningInformationCardProps {
    title: string;
    price: number | null;
    isDonate?: boolean;
    required?: string[];
    conflict?: string[];
    isBought?: boolean;
    isEquipped: boolean;
    handleBuy: () => void;
    handleEquip: () => void;
    showPalette?: boolean;
    color?: RGBColor;
    setColor?: (color: RGBColor) => void;
}

export const TuningInformationCard = (props: TuningInformationCardProps) => {
    const [language, setLanguage] = useState<Language>('ru');
    const t = translations[language];

    const [palette, setPalette] = useState<JSX.Element | null>(null);

    const getPalette = () => {
        if (props.showPalette) {
            return <ColorBlock 
                key={1}
                color={props.color}
                setColor={props.setColor}
            />;
        }
        return null;
    }

    useEffect(() => {
        setPalette(getPalette());
    }, [props.showPalette, props.color]);

    return (
        <div className='tuning-information-card'>
            <div className='tuning-information-card-header'>
                <h1>{props.title}</h1>
            </div>

            <div className='tuning-information-card-content'>
                
                <div className='tuning-information-block-list'>
                    {palette}
                    <div className='content-block' key={999}>
                        <div className='tuning-information-price-container'>
                            <p>{t.price}: {props.price ?? 0}</p>
                            <img
                                className='tuning-information-price-icon'
                                src={props.isDonate ? '/icons/32px/dp.png' : '/icons/32px/money.png'}
                                alt={props.isDonate ? 'DP' : '$'}
                            />
                        </div>
                        {!!props.conflict?.length && (
                            <p className='tuning-information-dependency'>
                                {t.tuning_conflict_list}: <b>{props.conflict.join(', ')}</b>
                            </p>
                        )}
                        {!!props.required?.length && (
                            <p className='tuning-information-dependency'>
                                {t.tuning_required_list}: <b>{props.required.join(', ')}</b>
                            </p>
                        )}
                    </div>
                </div>
                <div className='tuning-information-card-footer'>
                    { !props.isBought ? 
                        <div 
                            className='tuning-button tuning-buy-button' 
                            onClick={props.handleBuy}
                        >
                            <p>{t.buy}</p>
                        </div>
                        : 
                        <div 
                            className={`tuning-button tuning-equip-button ${props.isEquipped ? 'equipped' : ''}`} 
                            onClick={
                            () => {
                                props.handleEquip(); 
                            }
                        }>
                            {props.isEquipped ? <img className="equipped-icon" src="../icons/checked.png" alt="checked" /> : <p>{t.equip}</p>}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}